import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image collage */}
      <div className="absolute inset-0 mx-4 md:mx-6 my-4 md:my-6 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20collage%20of%20diverse%20fashion%20products%20including%20sneakers%20hoodies%20bags%20watches%20and%20accessories%20arranged%20in%20dynamic%20diagonal%20composition%2C%20soft%20warm%20cream%20and%20sand%20beige%20background%2C%20modern%20minimalist%20aesthetic%20with%20scattered%20product%20layout%2C%20gentle%20diffused%20natural%20lighting%20creating%20subtle%20depth%2C%20elevated%20luxury%20fashion%20photography%2C%20harmonious%20earthy%20color%20palette%2C%20clean%20sophisticated%20design&width=1600&height=900&seq=hero-v2-bg-2026&orientation=landscape"
          alt="itaobuy shopping products collage"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white text-xs md:text-sm font-medium mb-4 md:mb-6 tracking-wide">
            itaobuy Official Guide
          </span>
        </div>

        <h1 className="animate-fade-in-up delay-100 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-white max-w-3xl leading-tight md:leading-tight lg:leading-tight">
          The Smart Way to Shop Online Using{' '}
          <span className="text-secondary-300">itaobuyspreadsheet</span>
        </h1>

        <p className="animate-fade-in-up delay-200 text-sm md:text-base text-white/80 max-w-xl mt-3 md:mt-5 leading-relaxed">
          A powerful spreadsheet-based shopping system designed to help users track products, compare prices, and optimize purchasing decisions efficiently.
        </p>

        <div className="animate-fade-in-up delay-300 flex flex-col sm:flex-row items-center gap-3 mt-6 md:mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Access itaobuyspreadsheet System
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
          <button
            onClick={() => navigate('/article/itaobuyspreadsheet-complete-beginner-guide')}
            className="flex items-center gap-2 px-6 py-3 border border-white/50 text-white rounded-full text-sm md:text-base font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}